import { Box, Card, Skeleton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DataNotAvailable } from '../DataNotAvailable'

interface Props {
  title: string
  info: string
  time?: number | null
  emptyState?: string
}

export const TimeToChart = ({ title, info, time, emptyState }: Props) => (
  <Card>
    <Card.Title tooltip={info}>{title}</Card.Title>
    <Card.Content>
      {!time ? (
        <DataNotAvailable customMessage={emptyState} />
      ) : (
        <Box justifyContent="center" height="s32">
          {time !== undefined ? (
            <Text size="600" weight="medium" color="grey1000">
              {i18n.tp('ats.insights_page.main_metrics.days_indicator', { count: time })}
            </Text>
          ) : (
            <Box flexDirection="row" gap="s16">
              <Skeleton height="s16" width="s64" />
              <Skeleton height="s16" width="s80" />
            </Box>
          )}
        </Box>
      )}
    </Card.Content>
  </Card>
)
